module.exports = __webpack_public_path__ + "static/media/DiscoverMe_landscape.be2402f9.png";